// 导入 types.js 文件
import types from "../types";
import { Message } from 'element-ui';
import axios from 'axios';
import api from '@/api/api.js'
import  userStore from './store'

const state = {
	msgCount:"",
}
const mutations = {
	// 此处的事件为上方 actions 中的 commit(types.TPEOPLE)
	[types.MESSAGEINFO](state, data) {
		if (data) {
			state.msgCount = data
		}

	}
}
const actions = {
	MESSAGEINFO({
		commit
	}) {
		var formData = new FormData(); // 创建form对象
		axios
			.post(api + "/back/agentOrder/message-count", formData, {
				headers: {
					"x-auth-token": userStore.state.logininfo.user.token,
				},
			})
			.then((res) => {
				if (res.data.code == 0) {
					commit(types.MESSAGEINFO, res.data.data.count)
				} else {
					Message.error(res.data.msg)
				}
			});

	}
}
export default {
	state,
	actions,
	mutations
}